/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const EditorWrapper = styled.div`
  position: relative;
  min-height: 2rem;
  height: 100%;

  &.edited {
    border-color: var(--cds-border-strong);
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  & .cm-gutters {
    background-color: var(--cds-background);
    padding: 0px;
    border: none;
  }

  & .cm-gutter {
    min-width: 30px;
  }

  & .cm-lineNumbers .cm-gutterElement {
    text-align: center;
  }

  & .cm-content {
    padding: var(--cds-spacing-02);
  }
`;
